Groupon.verifyUserCookies = function() {
  return setTimeout((function() {
    var el, ref, src;
    if (!(src = Groupon.endpoints.verifyCookies)) {
      return;
    }
    if ((ref = window.sessionStorage) != null ? ref.getItem('verifiedCookies') : void 0) {
      return;
    }
    el = document.createElement('script');
    el.id = 'verify_cookies';
    el.async = true;
    document.body.appendChild(el).src = src;
    try {
      return typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.setItem('verifiedCookies', true) : void 0;
    } catch (error) {}
  }), 0);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3ZlcmlmeVVzZXJDb29raWVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy92ZXJpZnlVc2VyQ29va2llcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxDQUFDLGlCQUFSLEdBQTRCLFNBQUE7U0FDMUIsVUFBQSxDQUFXLENBQUMsU0FBQTtBQUNWLFFBQUE7SUFBQSxJQUFBLENBQWMsQ0FBQSxHQUFBLEdBQU0sT0FBTyxDQUFDLFNBQVMsQ0FBQyxhQUF4QixDQUFkO0FBQUEsYUFBQTs7SUFFQSwrQ0FBK0IsQ0FBRSxPQUF2QixDQUErQixpQkFBL0IsVUFBVjtBQUFBLGFBQUE7O0lBQ0EsRUFBQSxHQUFLLFFBQVEsQ0FBQyxhQUFULENBQXVCLFFBQXZCO0lBQ0wsRUFBRSxDQUFDLEVBQUgsR0FBUTtJQUNSLEVBQUUsQ0FBQyxLQUFILEdBQVc7SUFDWCxRQUFRLENBQUMsSUFBSSxDQUFDLFdBQWQsQ0FBMEIsRUFBMUIsQ0FBNkIsQ0FBQyxHQUE5QixHQUFvQztBQUNwQztnRkFDRSxjQUFjLENBQUUsT0FBaEIsQ0FBd0IsaUJBQXhCLEVBQTJDLElBQTNDLFdBREY7S0FBQTtFQVJVLENBQUQsQ0FBWCxFQVVDLENBVkQ7QUFEMEIifQ==
